import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/deals/$dealId_/capabilities")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/deals/$dealId/reports",
      params: { dealId: params.dealId },
      search: { product: "investor_readiness" },
    });
  },
});
